var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangupWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.721,
    height: 21,
    viewBox: "0 0 24.721 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "LOGOUT_ICON",
    "data-name": "LOGOUT ICON",
    d: "M3.182-1460A3.186,3.186,0,0,1,0-1463.182v-13.636A3.185,3.185,0,0,1,3.182-1480h8.636a3.97,3.97,0,0,1,2.395.859,3.007,3.007,0,0,1,1.241,2.323v2.273a.909.909,0,0,1-.908.909.909.909,0,0,1-.91-.909v-2.273c0-.65-.951-1.364-1.818-1.364H3.182a1.366,1.366,0,0,0-1.364,1.364v13.636a1.366,1.366,0,0,0,1.364,1.364h9.091a1.365,1.365,0,0,0,1.363-1.364v-2.272a.91.91,0,0,1,.91-.909.909.909,0,0,1,.908.909v2.272A3.186,3.186,0,0,1,12.273-1460Zm14.357-4.811a.909.909,0,0,1,0-1.286l2.993-2.993H7.273a.91.91,0,0,1-.91-.909.909.909,0,0,1,.91-.909h13.26l-2.993-2.993a.909.909,0,0,1,0-1.286.91.91,0,0,1,1.286,0l4.545,4.546a.909.909,0,0,1,0,1.285l-4.545,4.546a.909.909,0,0,1-.643.266A.907.907,0,0,1,17.539-1464.811Z",
    transform: "translate(0.5 1480.5)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangupWhite);
export default __webpack_public_path__ + "static/media/hangup-white.bbd6278c.svg";
export { ForwardRef as ReactComponent };